import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LoaderCircleIcon } from 'lucide-react';
const tasks = ['Adres opzoeken', 'Gebouwgegevens ophalen uit de BAG', 'Dakvlak meten op de luchtfoto', 'Zonpotentieel berekenen'];
export function ScanProgress() {
  const [done, setDone] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setDone(d => Math.min(d + 1, tasks.length - 1)), 520);
    return () => window.clearInterval(id);
  }, []);
  return <div className="py-6" role="status" aria-live="polite" data-id="element-466" data-mp="3md9t6iin0o33">
      <h1 className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-467" data-mp="3hli82ni93akc">Je woning wordt gescand…</h1>
      <p className="mt-3 text-lg text-ink-soft" data-id="element-468" data-mp="3cmyo2sn7w8um">Dit duurt een paar seconden.</p>
      <ul className="mt-10 space-y-5" data-id="element-469" data-mp="dweyvrfwoc0m">
        {tasks.map((t, i) => {
        const state = i < done ? 'done' : i === done ? 'active' : 'pending';
        return <motion.li key={t} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: state === 'pending' ? 0.4 : 1,
          y: 0
        }} transition={{
          duration: 0.2,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-4 text-[17px] text-ink" data-id="element-470" data-mp="94dsun9bzhj1" data-mpi={i}>
              <span className={`flex h-8 w-8 items-center justify-center rounded-full ${state === 'done' ? 'bg-volt text-ink' : 'border border-line bg-white text-ink-muted'}`} data-id="element-471" data-mp="36reufhez4iiw">
                {state === 'done' ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-472" data-mp="2wr5xg1d5qt2g" /> : state === 'active' ? <LoaderCircleIcon className="h-4 w-4 animate-spin motion-reduce:animate-none" aria-hidden="true" data-id="element-473" data-mp="2nskew67ore1o" /> : null}
              </span>
              {t}
            </motion.li>;
      })}
      </ul>
    </div>;
}